import type { useTheme } from './theme';

// THE logger's tip bubble look: ink fill, bg text, r2, comfortable padding.
// One definition read by the card's balloon (useTransientTip) and the column
// header's (HeaderTooltip), which used to carry two copies of it (#308
// review). Plain objects, so each caller adds its own placement on top.
export function bubbleStyle(theme: ReturnType<typeof useTheme>) {
  const { palette: p, spacing: s, radius: r, typography: ty } = theme;
  return {
    box: {
      backgroundColor: p.ink,
      borderRadius: r.r2,
      paddingHorizontal: s.s3,
      paddingVertical: s.s2,
    },
    text: {
      color: p.bg,
      fontSize: ty.sizes.xs,
      lineHeight: ty.sizes.xs * 1.4,
      fontWeight: '500' as const,
    },
  };
}
